import { css } from '@emotion/react';
import { ZapTemplate } from '@zapier/authentication';
import { Colors, Typography } from '@zapier/design-system';
import { mediaQueries } from '@zapier/identity-utils';
import { useTranslations } from 'next-intl';

type Props = {
  zapTemplate: ZapTemplate;
};

const titleStyle = css`
  ${Typography.SectionHeader}
  color: ${Colors.GrayWarm9};
  margin-bottom: 30px;
  text-align: center;

  ${mediaQueries.desktop} {
    ${Typography.PageHeader}
  }
  ${Typography.PageHeader}
  color: ${Colors.GrayWarm10};
  ${mediaQueries.desktop} {
    ${Typography.PageHeader}
  }
`;

export function ZapTemplateTitle({ zapTemplate }: Props) {
  const t = useTranslations('zap-template-title');

  if (
    zapTemplate.tailService &&
    zapTemplate.tailService.name !== zapTemplate.headService.name
  ) {
    return (
      <h1 css={[titleStyle]}>
        {t('title-with-services', {
          headService: zapTemplate.headService?.name,
          tailService: zapTemplate.tailService?.name,
        })}
      </h1>
    );
  }

  return <h1 css={titleStyle}>{t('title-default')}</h1>;
}
